export const EXTENSION_TYPE_NAME = 'da-gif';

//# sourceMappingURL=constants.js.map